import Typography from "../typography/typography";
import { Box } from "@mui/material";
import "./fallback.scss";

interface FallbackProps {
  heading: string;
  subHeading: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
}

const Fallback = (props: FallbackProps) => {
  const { heading, subHeading, icon, children, ...rest } = props;
  return (
    <Box className="fallback" {...rest}>
      {icon}
      <Typography
        type="h5"
        weight="medium"
        color="theme.secondary.1000"
        className="fallback--Text"
      >
        {heading}
      </Typography>
      <Typography
        type="s3"
        weight="medium"
        color="theme.secondary.800"
        className="fallback--Text"
      >
        {subHeading}
      </Typography>
      <div>{children}</div>
    </Box>
  );
};

export { Fallback };
export default Fallback;
